export const divisionChoices = [
	{ id: 'I', name: 'I' },
	{ id: 'II', name: 'II' },
	{ id: 'III', name: 'III' },
	{ id: 'IV', name: 'IV' },
	{ id: 'V', name: 'V' },
]
export default divisionChoices